import { Stack } from "@vapor/react-material";
import { useTranslation } from "@onefront/react-sdk";
import { FiltersProps } from "../../../newDocuments/types";
import { SpaceManagementLinearProgressBar } from "../../../newDocuments/document-components/SpaceManagementLinearProgressBar";
import LeftPannel from "./LeftPannel";
import { LeftPanelScrollbar } from "../../../newDocuments/document-styled-components/LeftPanelScrollbar";

const LeftPanelComponent = ({
  freeSpace,
  totalSpace,
  usedSpace,
  spaceManagementError,
  setSearchValue,
  handleFilterChange,
  documentFilterOption,
}: any) => {
  const { t } = useTranslation("DOCS");
  let renderSpaceManagement = totalSpace?.toString();
  return (
    <>
      <LeftPanelScrollbar
        style={{ maxHeight: "70vh" }}
        autoHide={true}
        scrollbarMinSize={50}
        scrollbarMaxSize={80}
      >
        <Stack direction="column" spacing={4}>
          <LeftPannel
            setSearchValue={setSearchValue}
            handleFilterChange={handleFilterChange}
            documentFilterOption={documentFilterOption}
          />
          {renderSpaceManagement && (
            <SpaceManagementLinearProgressBar
              freeSpace={freeSpace}
              totalSpace={totalSpace}
              usedSpace={usedSpace}
            />
          )}
        </Stack>
      </LeftPanelScrollbar>
    </>
  );
};

export default LeftPanelComponent;
